export default "__VITE_ASSET__DCQ6ngTW__"